import { motion } from "framer-motion";

export const fadeUp = {
    initial: { opacity: 0, y: 32 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.15 },
    transition: { duration: 0.7, ease: [0.215, 0.61, 0.355, 1] },
};

export const Reveal = ({ children, delay = 0, className, ...rest }) => (
    <motion.div
        {...fadeUp}
        {...rest}
        transition={{ ...fadeUp.transition, delay }}
        className={className}
    >
        {children}
    </motion.div>
);

export default Reveal;
